/** Levée lorsqu'un commerçant démo tente une écriture API. */
export class DemoPersistBlockedError extends Error {
  constructor() {
    super('DEMO_PERSIST_BLOCKED');
    this.name = 'DemoPersistBlockedError';
  }
}

export function isDemoPersistBlockedError(err: unknown): boolean {
  return err instanceof DemoPersistBlockedError
    || (err instanceof Error && err.message === 'DEMO_PERSIST_BLOCKED');
}
